import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getRiepilogo } from '../services/budgetService';
import { saveRiepilogo } from '../services/budgetService';

const RiepilogoTabella = ({
  totaleSpeseTecniche,
  totaleCostoDiCostruzione,
  setRiepilogoEsistente,
  riepilogoEsistente,
  cantiereId,
  totaleRealizzoAlloggio,
  totaleRealizzoBox
                          }) => {
    const { cantiereId: routeCantiereId } = useParams();
    cantiereId = cantiereId || routeCantiereId;
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [agenziePercent, setAgenziePercent] = useState('');
    const isEmpty = !riepilogoEsistente || Object.keys(riepilogoEsistente).length === 0;

    useEffect(() => {
      if (!cantiereId) return;

      const fetchData = async () => {
        try {
          const response = await getRiepilogo(cantiereId);
          setRiepilogoEsistente(response.data);
          if (!response.data || Object.keys(response.data).length === 0) {
            setEditMode(true);
          }
          setLoading(false);
        } catch (error) {
          console.error("Errore nel caricamento del riepilogo:", error);
          setEditMode(true);
          setLoading(false);
        }
      };

      setLoading(true);
      fetchData();
    }, [cantiereId, setRiepilogoEsistente]);

    useEffect(() => {
      const totaleVendita = (Number(totaleRealizzoAlloggio) || 0) + (Number(totaleRealizzoBox) || 0);
      if (riepilogoEsistente && totaleVendita) {
        setAgenziePercent(
          riepilogoEsistente.agenzie
            ? (riepilogoEsistente.agenzie / totaleVendita) * 100
            : ''
        );
      }
    }, [riepilogoEsistente, totaleRealizzoAlloggio, totaleRealizzoBox]);

    if (loading) return <p>Caricamento dati riepilogo...</p>;

    if (editMode || isEmpty) {
      return (
        <div className="p-4 border rounded bg-light">
          <h4 className="mb-4">{isEmpty ? 'Crea Riepilogo' : 'Modifica Riepilogo'}</h4>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const totaleVendita = (Number(totaleRealizzoAlloggio) || 0) + (Number(totaleRealizzoBox) || 0);
              const valoreAgenzie = agenziePercent !== ''
                ? totaleVendita * (parseFloat(agenziePercent) / 100)
                : 0;
              // Costruisci l'oggetto datiRiepilogo
                const { oneri_di_occupazione_suolo_pubblico, ...rest } = riepilogoEsistente;
                const datiRiepilogo = {
                    ...rest,
                    agenzie: valoreAgenzie,
                    occupazione_suolo: oneri_di_occupazione_suolo_pubblico,
                };
              // Aggiungi codici di riferimento come richiesto
              const CODICI_RIFERIMENTO = {
                'Costo Terreno': 'A001',
                'Intermediazione acquisto': 'A002',
                'Spese Registro': 'A003',
                'Oneri di Urbanizzazione': 'A004',
                'Spese Notarili': 'A005',
                'Cambio Camera': 'A006',
                'Costo amministrazione': 'D001',
                'Costo Pratiche Comunali': 'D002',
                'Fideiussioni': 'D003',
                'Assicurazioni': 'D004',
                'IMU': 'D005',
                'Oneri di Occupazione suolo pubblico': 'D006',
                'Stampe varie': 'D008',
                'Agenzie': 'E001',
                'Pubblicità e Grafica pubblicitaria': 'E002',
                'Istruttoria': 'F001',
                'Perizia Mutuo': 'F002',
                'Interessi': 'F003',
                'Interessi Investitori': 'F007',
                'interessi_investitori': 'F007',
                'Commissioni Transazioni': 'F004',
                'Commissioni Fido': 'F005',
                'Spese Mutuo': 'F006',
                'Vendita Residenziale': 'G018',
                'Vendita Box': 'G019',
                'Varianti Alloggi': 'I011',
              };
              const datiRiepilogoConCodici = {
                ...datiRiepilogo,
                codici_riferimento: {},
              };
              for (const voce of Object.keys(datiRiepilogo)) {
                if (CODICI_RIFERIMENTO[voce]) {
                  datiRiepilogoConCodici.codici_riferimento[voce] = CODICI_RIFERIMENTO[voce];
                }
              }
              await saveRiepilogo(cantiereId, datiRiepilogoConCodici);
              const updated = await getRiepilogo(cantiereId);
              setRiepilogoEsistente(updated.data);
              setEditMode(!(updated.data && Object.keys(updated.data).length > 0));
            }}
          >
            {/* Superfici */}
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Superficie Commerciale</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.superficie_commerciale || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, superficie_commerciale: e.target.value })
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">SLP</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.superficie_slp || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, superficie_slp: e.target.value })
                  }
                />
              </div>
            </div>

            {/* A00 – Acquisto Terreno */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Costo Terreno</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.costo_terreno || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, costo_terreno: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Intermediazione Acquisto</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.intermediazione_acquisto || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, intermediazione_acquisto: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Spese Registro</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.spese_registro || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, spese_registro: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Spese Notarili</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.spese_notarili || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, spese_notarili: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Cambio Camera</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.cambio_camera || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, cambio_camera: e.target.value })
                  }
                />
              </div>
            </div>

            {/* D00 – Costi Vari */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Costo Pratiche Comunali</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.costo_pratiche_comunali || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, costo_pratiche_comunali: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Fideiussioni</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.fideiussioni || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, fideiussioni: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Assicurazioni</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.assicurazioni || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, assicurazioni: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">IMU</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.imu || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, imu: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Oneri di Occupazione suolo pubblico</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.oneri_di_occupazione_suolo_pubblico || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, oneri_di_occupazione_suolo_pubblico: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Stampe varie</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.stampe_varie || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, stampe_varie: e.target.value })
                  }
                />
              </div>
            </div>

            {/* E00 COMMERCIALIZZAZIONE */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Agenzie - inserisci %</label>
                <input
                  type="number"
                  className="form-control"
                  value={agenziePercent}
                  onChange={(e) => setAgenziePercent(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Frenk</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.frenk || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, frenk: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Pubblicità e Grafica pubblicitaria</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.pubblicità_e_grafica_pubblicitaria || riepilogoEsistente.pubblicit_e_grafica_pubblicitaria || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, pubblicità_e_grafica_pubblicitaria: e.target.value, pubblicit_e_grafica_pubblicitaria: e.target.value })
                  }
                />
              </div>
            </div>

            {/* F00 COSTI BANCA */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Istruttoria</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.istruttoria || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, istruttoria: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Perizia Mutuo</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.perizia_mutuo || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, perizia_mutuo: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Interessi Investitori</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.interessi_investitori || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, interessi_investitori: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Commissioni Transazioni</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.commissioni_transazioni || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, commissioni_transazioni: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Commissioni Fido</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.commissioni_fido || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, commissioni_fido: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Spese Mutuo</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.spese_mutuo || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, spese_mutuo: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Sconto</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.sconto || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, sconto: e.target.value })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Varianti Alloggi</label>
                <input
                  type="number"
                  className="form-control"
                  value={riepilogoEsistente.varianti_alloggi || ''}
                  onChange={(e) =>
                      setRiepilogoEsistente({ ...riepilogoEsistente, varianti_alloggi: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="mt-3">
              <button type="submit" className="btn btn-success me-2">Salva</button>
              <button type="button" className="btn btn-secondary" onClick={() => setEditMode(false)}>Annulla</button>
            </div>
          </form>
        </div>
      );
    }


    const chiaviTerreno = [
        'costo_terreno',
        'intermediazione_acquisto',
        'spese_registro',
        'spese_notarili',
        'cambio_camera'
    ];

    const totaleOneri = Number(riepilogoEsistente.totale_oneri) * Number(riepilogoEsistente.superficie_slp);


    const totale_terreno = chiaviTerreno.reduce((somma, chiave) => {
        const valoreGrezzo = riepilogoEsistente[chiave];
        const valore = Number(valoreGrezzo) || 0;
        return somma + valore;
    }, 0) + totaleOneri;

    const chiaviCostiVari = [
        'costo_amministrazione',
        'costo_pratiche_comunali',
        'fideiussioni',
        'assicurazioni',
        'imu',
        'oneri_di_occupazione_suolo_pubblico',
        'stampe_varie'
    ];

    const totale_costi_vari = chiaviCostiVari.reduce((somma, chiave) => {
        const valore = Number(riepilogoEsistente[chiave]) || 0;
        return somma + valore;
    }, 0);

    const chiaviCommercializzazione = [
        'agenzie',
        'frenk',
        'pubblicità_e_grafica_pubblicitaria'
    ];

    const totale_commercializzazione = chiaviCommercializzazione.reduce((somma, chiave) => {
        const valore = Number(riepilogoEsistente[chiave]) || 0;
        return somma + valore;
    }, 0);

    const chiaviCostiBanca = [
        'istruttoria',
        'perizia_mutuo',
        'interessi',
        'interessi_investitori',
        'commissioni_transazioni',
        'commissioni_fido',
        'spese_mutuo',
    ];

    const totale_costi_banca = chiaviCostiBanca.reduce((somma, chiave) => {
        const valore = Number(riepilogoEsistente[chiave]) || 0;
        return somma + valore;
    }, 0);

    const totale_costi = totale_terreno + totaleSpeseTecniche + totaleCostoDiCostruzione + totale_costi_vari + totale_commercializzazione + totale_costi_banca;

    const totale_vendita =
        (Number(totaleRealizzoAlloggio) || 0) +
        (Number(totaleRealizzoBox) || 0) +
        (Number(riepilogoEsistente.varianti_alloggi) || 0);

    const margine_operativo = totale_vendita - totale_costi + totale_costi_banca;
    const margine_lordo = margine_operativo - totale_costi_banca;
    const margine_operativo_ricavi = totale_vendita ? (margine_operativo / totale_vendita) * 100 : 0;
    const margine_operativo_costi = totale_costi ? (margine_operativo / totale_costi) * 100 : 0;
    const margine_lordo_ricavi = totale_vendita ? (margine_lordo / totale_vendita) * 100 : 0;
    const margine_lordo_costi = totale_costi ? (margine_lordo / totale_costi) * 100 : 0;
    console.log('riepilogoEsistente:', riepilogoEsistente);

    return (
        <>
            <div className="mb-4 p-3 border rounded bg-light">
                <h5 className="mb-3">Superfici</h5>
                <div className="row">
                    <div className="col-md-4">
                        <strong>SLP:</strong> {riepilogoEsistente?.superficie_slp !== undefined && riepilogoEsistente?.superficie_slp !== null
                          ? new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(Number(riepilogoEsistente.superficie_slp))
                          : '—'} m²
                    </div>
                    <div className="col-md-4">
                        <strong>Commerciale:</strong> {new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(Number(riepilogoEsistente.superficie_commerciale)) || '—'} m²
                    </div>
                    <div className="col-md-4">
                        <strong>Incidenza:</strong> {
                          Number(riepilogoEsistente.superficie_slp) && Number(riepilogoEsistente.superficie_slp) !== 0
                            ? (((Number(riepilogoEsistente.superficie_commerciale) - Number(riepilogoEsistente.superficie_slp)) / Number(riepilogoEsistente.superficie_slp)) * 100).toFixed(2) + '%'
                            : '—'
                        }
                    </div>
                </div>

                {/* A00 – Acquisto Terreno */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">A00 Terreno</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                              <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                              </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Costo Terreno</td>
                                <td>{riepilogoEsistente.costo_terreno
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.costo_terreno)
                                    : '—'}</td>
                                <td>{riepilogoEsistente.codice_riferimento_costo_terreno || '—'}</td>
                            </tr>
                            <tr>
                                <td>Intermediazione Acquisto</td>
                                <td>{riepilogoEsistente.intermediazione_acquisto
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.intermediazione_acquisto)
                                    : '—'}</td>
                                <td>{riepilogoEsistente.codice_riferimento_intermediazione_acquisto || '—'}</td>
                            </tr>
                            <tr>
                                <td>Spese Registro</td>
                                <td>{riepilogoEsistente.spese_registro
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.spese_registro)
                                    : '—'}</td>
                                <td>{riepilogoEsistente.codice_riferimento_spese_registro || '—'}</td>
                            </tr>
                            <tr>
                                <td>Oneri di Urbanizzazione</td>
                                <td>
                                    {riepilogoEsistente.totale_oneri && riepilogoEsistente.superficie_slp
                                        ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(
                                            parseFloat(riepilogoEsistente.totale_oneri.toString().replace(',', '.')) *
                                            parseFloat(riepilogoEsistente.superficie_slp)
                                        )
                                        : '—'}
                                </td>
                                <td>{riepilogoEsistente.codice_riferimento_oneri_di_urbanizzazione || '—'}</td>
                            </tr>
                            <tr>
                                <td>Spese Notarili</td>
                                <td>{riepilogoEsistente.spese_notarili
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.spese_notarili)
                                    : '—'}</td>
                                <td>{riepilogoEsistente.codice_riferimento_spese_notarili || '—'}</td>
                            </tr>
                            <tr>
                                <td>Cambio Camera</td>
                               <td> {riepilogoEsistente.cambio_camera
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.cambio_camera)
                                    : '—'}</td>
                                <td>{riepilogoEsistente.codice_riferimento_cambio_camera || '—'}</td>
                            </tr>
                            <tr>
                                <td><b>TOTALE</b></td>
                                <td><b>{ totale_terreno
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_terreno)
                                    : '—'}</b></td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* B00 – Spese Tecniche */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">B00 Spese Tecniche</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Spese Tecniche</td>
                                <td>
                                    <b>{typeof totaleSpeseTecniche === 'number' && !isNaN(totaleSpeseTecniche)
                                        ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totaleSpeseTecniche)
                                        : '—'}</b>
                                </td>
                                <td>B00</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* C00 – Costruzione */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">C00 Costruzione</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Costruzione residenziale</td>
                                <td>
                                    <b>{typeof totaleCostoDiCostruzione === 'number' && !isNaN(totaleCostoDiCostruzione)
                                        ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totaleCostoDiCostruzione)
                                        : '—'}</b>
                                </td>
                                <td>C000</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* D00 – Costi Vari */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">D00 Costi Vari</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Costo Amministrazione</td>
                                <td>{typeof riepilogoEsistente.costo_amministrazione === 'number' && !isNaN(riepilogoEsistente.costo_amministrazione)
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.costo_amministrazione)
                                    : '—'}</td>
                                <td>D001</td>
                            </tr>
                            <tr>
                                <td>Costo Pratiche Comunali</td>
                                <td>{riepilogoEsistente.costo_pratiche_comunali
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.costo_pratiche_comunali)
                                    : '—'} </td>
                                <td>D002</td>
                            </tr>
                            <tr>
                                <td>Fidejussioni</td>
                                <td>{riepilogoEsistente.fideiussioni
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.fideiussioni)
                                    : '—'}
                                </td>
                                <td>{riepilogoEsistente.codice_riferimento_fideiussioni || '—'}</td>
                            </tr>
                            <tr>
                                <td>Assicurazioni</td>
                                <td>{riepilogoEsistente.assicurazioni
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.assicurazioni)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_assicurazioni || '—'}</td>
                            </tr>
                            <tr>
                                <td>IMU</td>
                                <td>{riepilogoEsistente.imu
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.imu)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_imu || '—'}</td>
                            </tr>
                            <tr>
                                <td>Oneri di Occupazione suolo pubblico </td>
                                <td>{riepilogoEsistente.oneri_di_occupazione_suolo_pubblico
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.oneri_di_occupazione_suolo_pubblico)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_oneri_di_occupazione_suolo_pubblico || '—'}</td>
                            </tr>
                            <tr>
                                <td>Stampe varie </td>
                                <td>{riepilogoEsistente.stampe_varie
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.stampe_varie)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_stampe_varie || '—'}</td>
                            </tr>
                            <tr>
                                <td><b>TOTALE</b> </td>
                                <td><b>{totale_costi_vari
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_costi_vari)
                                    : '—'}</b></td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* E00 COMMERCIALIZZAZIONE */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">E00 COMMERCIALIZZAZIONE</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Agenzia</td>
                                <td>{riepilogoEsistente.agenzie ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.agenzie)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_agenzie || '—'}</td>
                            </tr>
                            <tr>
                                <td>Frenk</td>
                                <td>{typeof riepilogoEsistente.frenk === 'number' && !isNaN(riepilogoEsistente.frenk)
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.frenk)
                                    : '—'} </td>
                                <td>E000</td>
                            </tr>
                            <tr>
                                <td>Pubblicità e Grafica pubblicitaria</td>
                                <td>{riepilogoEsistente.pubblicità_e_grafica_pubblicitaria
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.pubblicità_e_grafica_pubblicitaria)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_pubblicità_e_grafica_pubblicitaria || '—'}</td>
                            </tr>
                            <tr>
                                <td><b>TOTALE</b></td>
                                <td><b>{totale_commercializzazione
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_commercializzazione)
                                    : '—'}</b></td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* F00 COSTI BANCA */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">F00 COSTI BANCA</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Istruttoria</td>
                                <td>{riepilogoEsistente.istruttoria
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.istruttoria)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_istruttoria || '—'}</td>
                            </tr>
                            <tr>
                                <td>Perizia Mutuo</td>
                                <td>{riepilogoEsistente.perizia_mutuo
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.perizia_mutuo)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_perizia_mutuo || '—'}</td>
                            </tr>
                            <tr>
                                <td>Interessi</td>
                                <td>{riepilogoEsistente.interessi
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.interessi)
                                    : '—'} </td>
                                <td>F003</td>
                            </tr>
                            <tr>
                                <td>Interessi Investitori</td>
                                <td>{riepilogoEsistente.interessi_investitori
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.interessi_investitori)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_interessi_investitori || 'F007'}</td>
                            </tr>
                            <tr>
                                <td>Commissioni Transazioni</td>
                                <td>{riepilogoEsistente.commissioni_transazioni
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.commissioni_transazioni)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_commissioni_transazioni || '—'}</td>
                            </tr>
                            <tr>
                                <td>Commissioni Fido</td>
                                <td>{riepilogoEsistente.commissioni_fido
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.commissioni_fido)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_commissioni_fido || '—'}</td>
                            </tr>
                            <tr>
                                <td>Spese Mutuo</td>
                                <td>{riepilogoEsistente.spese_mutuo
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.spese_mutuo)
                                    : '—'} </td>
                                <td>{riepilogoEsistente.codice_riferimento_spese_mutuo || '—'}</td>
                            </tr>
                            <tr>
                                <td><b>TOTALE</b></td>
                                <td><b>{totale_costi_banca
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_costi_banca)
                                    : '—'}</b></td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* TOTALE */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">TOTALE</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th style={{textAlign:"right"}}>Importo (€)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Totale Costi</td>
                                <td style={{textAlign:"right", fontSize:"1.2rem", fontWeight:"800", color:"red"}}>{totale_costi
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_costi)
                                    : '—'} </td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* G100 RICAVI */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">G100 RICAVI</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Vendita Residenziale</td>
                                <td>{new Intl.NumberFormat('it-IT', {
                                    style: 'currency',
                                    currency: 'EUR',
                                }).format(totaleRealizzoAlloggio || 0)}</td>
                                <td>G018</td>
                            </tr>
                            <tr>
                                <td>Vendita Box</td>
                                <td>{new Intl.NumberFormat('it-IT', {
                                    style: 'currency',
                                    currency: 'EUR',
                                }).format(totaleRealizzoBox || 0)}</td>
                                <td>G019</td>
                            </tr>
                            <tr>
                                <td>Varianti Alloggi</td>
                                <td>{riepilogoEsistente.varianti_alloggi
                                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(riepilogoEsistente.varianti_alloggi)
                                    : '—'} </td>
                                <td>I011</td>
                            </tr>
                            <tr>
                                <td>Sconto</td>
                                <td>
                                    {riepilogoEsistente.sconto !== undefined && riepilogoEsistente.sconto !== ''
                                        ? `${parseFloat(riepilogoEsistente.sconto).toFixed(0)}%`
                                        : '—'}
                                </td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td><b>TOTALE</b></td>
                                <td colSpan={2} style={{ color: 'green', fontWeight: 'bold', fontSize: '1.2rem', textAlign: 'right' }}>
                                    {totale_vendita
                                        ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(totale_vendita)
                                        : '—'}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* MARGINI */}
                <div className="mb-4 p-3 border rounded bg-light">
                    <h5 className="mb-3">MARGINI</h5>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="table-secondary">
                            <tr>
                                <th>Voce</th>
                                <th>Importo (€)</th>
                                <th>Codice di riferimento</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>MARGINE OPERATIVO</td>
                                <td>{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(margine_operativo)}</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>MARGINE OPERATIVO/RICAVI</td>
                                <td>{margine_operativo_ricavi.toFixed(2)}%</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>MARGINE OPERATIVO/COSTI</td>
                                <td>{margine_operativo_costi.toFixed(2)}%</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>MARGINE LORDO</td>
                                <td>{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(margine_lordo)}</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>MARGINE LORDO/RICAVI</td>
                                <td>{margine_lordo_ricavi.toFixed(2)}%</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>MARGINE LORDO/COSTI</td>
                                <td>{margine_lordo_costi.toFixed(2)}%</td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="text-end mt-3">
              <button className="btn btn-warning" onClick={() => setEditMode(true)}>
                ✏️ Modifica Dati
              </button>
            </div>
        </>
    );
};
export default RiepilogoTabella;